module.exports = __webpack_public_path__ + "img/CM-BS-25-BMW-Playful.92c8f53c.jpg";